import React, {useEffect, useState} from 'react';
import {
  Grid, Button, Stack, Box, Avatar,
  Paper, Typography,Alert,AlertTitle, Link
} from '@mui/material';
import {Link as RouterLink} from 'react-router-dom';


import theGearLogo from '../media/theGEAR_color.png'

import {useAppAuthContext} from '../utils/AppAuthContext'
import {usePlayContext} from '../utils/PlayContext'
import useWindowDimensions from '../utils/useWindowDimensions'
import {  
  selectAllFloors,
  //selectSiteById,
  //selectSiteIds,
}  from '../store/floorSlice'
import { useSelector } from 'react-redux';


const HomePage = () => {

  const {userInfo, loginComplete, tenantName,tenantLogo} = useAppAuthContext()
  const {setAppTitle,   errorMessage,  errorTitle, 
    } = usePlayContext()
  
  const { height, width } = useWindowDimensions();

  const floors = useSelector(selectAllFloors);
  useEffect(()=>{
    setAppTitle(['Home'])
  }, 
  [])

  return (
    <Box sx={{border:'none', justifyContent: "flex-start", p: 1, mt:1}}>
         
      <Paper sx={{border:'none', justifyContent: "flex-start", p: 0, }} elevation={0} >
            <Grid
              container
              spacing={0}
              direction={'column'}
              justify={'center'}
              alignItems={'center'}
            >
              {/** 
            <Grid item xs={12} sx={{pt:1, display:'flex'}}>
              <Typography variant='h6' sx={{align:'center'}} >
                Visitor Management System
              </Typography>
            </Grid>
            */}
            <Grid item xs={12} sx={{pt:0,  display:'flex'}}>
            <img src={theGearLogo}  
							className='the-fold-logo'
							
						width='156' height='32'  />
             
            </Grid>
            <Grid item xs={12} sx={{pt:0}}>
              <Typography variant='h6' sx={{align:'center'}} >
              <small>{userInfo.name}&nbsp;&nbsp;
              
              ({userInfo.idTokenClaims.roles &&
              userInfo.idTokenClaims.roles.map((role, i) => [
                  i > 0 && ", ",
                  role
              ])})</small>
              </Typography>
            </Grid>
			{userInfo.idTokenClaims.roles &&
				userInfo.idTokenClaims.roles.includes('HOST') &&
				( !floors || floors.length==0) &&
			<Typography variant='h6' sx={{align:'center'}} >
              <small>You have not been assigned floor(s) in AEGIS </small>
              </Typography>
				
			}
          </Grid>
        

          {userInfo.idTokenClaims.roles &&
              userInfo.idTokenClaims.roles.includes('ADMIN') &&!userInfo.idTokenClaims.roles.includes('HOST') &&
          
          <Box sx={{p:3, display:{lg:'none', xs:'block'}}}>

                  <Typography variant='h5' sx={{align:'center', color:'error.main', textAlign:'center'}} >
                      To use the features properly, please use a HD screen with WIDTH greater than <strong>1200 pixels</strong>
                  </Typography>
          </Box>
          }
      </Paper>
    </Box>
  );
}

export default HomePage
